import {
    EuiBadge,
    EuiButton,
    EuiEmptyPrompt,
    EuiInMemoryTable,
    EuiPanel,
    EuiSpacer,
    EuiText,
    EuiTitle, formatDate
} from "@elastic/eui";

import {observer} from "mobx-react-lite";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {Store} from "../../../app/stores/store-root";
import "@elastic/eui/dist/eui_theme_amsterdam_light.css";
import {Order} from "../../../app/models/order";
import * as _ from "lodash";
import {NavLink, useHistory} from "react-router-dom";
import {SearchFilterConfig} from "@elastic/eui/src/components/search_bar/search_filters";
import {EuiSearchBarProps} from "@elastic/eui/src/components/search_bar/search_bar";

type dataProps = {
    items: Order[];
};
export const SendAgentOrdersList = ({items}: dataProps) => {
    const [error, setError] = useState(undefined);
    const [selection, setSelection] = useState([]);
    const [popOverOpen, setPopOverOpen] = useState(false);
    const history = useHistory();
    const store = useContext(Store);
    const selectionValue = {
        selectable: (order: any) => true,
        initialSelected: selection,
        onSelectionChange: (selection: any) => {
            setSelection(selection);
            console.log(selection);
        },
    };

    const [branches, setBranches] = useState<any[]>([]);
    const [agents, setAgents] = useState<any[]>([]);

    useEffect(() => {
        store.Lookups.loadLookups().then(() => {
            const transformed = store.Lookups.branchRegistry.map((item) => {
                return {"value": item.value, "name": item.label}
            });
            setBranches(transformed);
        });
        store.Orders.PendingApprovalOrders.loadItems().then(() => {
            const transformed = _.uniq(store.Orders.PendingApprovalOrders.Orders.map((item: Order) => {
                return {'value': item.CreatedByUserName, 'name': item.CreatedByName}
            }));
            setAgents(transformed);
        });
    }, [])


    const openSupportTicket=(order:any)=>{
        history.push(`/tickets/create/${order.Reference}`)
    }

    const actions: any[] = [
        {
            name: 'Support',
            description: 'Ask Admin for help',
            icon: 'help',
            type: 'icon',
            onClick: openSupportTicket,
        },
    ]

    const fields = [
        {
        field: 'Reference',
        name: 'Reference',
        sortable: true,
        truncateText: true,
        render: (reference: string) => {
            return (<NavLink to={`orders/edit/${reference}`}>
                {reference}
            </NavLink>)
        }
    },
        {
            field: 'SendingAmount',
            name: 'Sending Amount',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.SendingCurrencySymbol} ${value}`
            }

        },
        {
            field: 'ReceivingAmount',
            name: 'Receiving',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.ReceivingCurrencySymbol}${value}`
            }

        },
        {
            field: 'ExchangeRate',
            name: 'Rate',
            truncateText: true,
        },
        {
            field: 'DeliveryType',
            name: 'Trasnfer Type',
            truncateText: true,
            render: (type: any) => {
                return (type === "0") ? "Bank" : "Cash"
            }
        },
        {
            field: 'Status',
            name: 'Status',
            truncateText: true,
            render: (type: any) => {
                if (type === 0)
                    return <EuiBadge color="warning">Pending</EuiBadge>
                if (type === 1)
                    return <EuiBadge color="secondary">Ready</EuiBadge>
                if (type === 2)
                    return <EuiBadge color="primary">Paid</EuiBadge>
                if (type === 3)
                    return <EuiBadge>Rejected</EuiBadge>
                if (type === 4)
                    return <EuiBadge color="danger">Cancelled</EuiBadge>
                if (type === 5)
                    return <EuiBadge color="danger">In Progress</EuiBadge>

            }
        },

        {
            field: 'DeliveryOffice',
            name: 'Branch',
            truncateText: true,
            render: (branch: string) => {
                if (!branch)
                    return 'Bank Transfer'
                else
                    return branch
            }
        }
        ,
        {
            field: 'RemitterName',
            name: 'Remitter',


        },
        {
            field: 'BeneficiaryName',
            name: 'Beneficiary',


        },
        {
            field: 'CreatedAt',
            name: 'Created At',
            sortable: true,
            render: (date: any) => formatDate(date, "dobLong"),

        },
        {
            name: 'Actions',
            actions,
        }
    ]

    const searchFilters: SearchFilterConfig[] = [

        {
            type: 'field_value_selection',
            field: 'DeliveryOffice',
            name: 'Branch',
            multiSelect: true,
            options: branches
        },
        /*{
            type: 'field_value_selection',
            field: 'CreatedByUserName',
            name: 'Sending Agent',
            multiSelect: true,
            options: agents
        },*/
        {
            type: 'field_value_toggle_group',
            field: 'Status',
            items: [
                {
                    value: 0,
                    name: 'Pending Review'
                },
                {
                    value: 1,
                    name: 'Ready For Collection'
                },
                {
                    value: 2,
                    name: 'Paid'
                },
                {
                    value: 3,
                    name: 'Rejected'
                },
                {
                    value: 4,
                    name: 'Cancelled'
                }
            ]
        },
    ]
    const renderToolsRight = () => {
        return [
            <EuiButton
                key="loadUsers"
                size="s" fill
                onClick={() => {
                }}
            >
                Approve
            </EuiButton>,
            <EuiButton
                key="loadUsersError"
                size="s"
                onClick={() => {
                }}
            >
                Reject
            </EuiButton>,
        ];
    };

    const searchSettings: EuiSearchBarProps = {
        //toolsLeft: renderToolsRight(),
        box: {
            incremental: true,
            schema: true,
            placeholder: ''
        },
        filters: searchFilters
    }


    const [message, setMessage] = useState(
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>You have no orders</h2>}
            body={
                <Fragment>

                </Fragment>
            }
            actions={
                <EuiButton color="primary" fill>
                    Load orders
                </EuiButton>
            }
        />
    );
    //Load orders data




    return (
        <EuiPanel paddingSize="l" hasShadow>
            <EuiText>
                <h3>Orders History</h3>
                <p>
                    This section lists all money transfer orders you have created. You can filter and sort your records by status, user name, and pickup office
                </p>
            </EuiText>
            <EuiSpacer size={"xxl"}/>
            <EuiInMemoryTable
                items={items}
                itemId="Reference"
                hasActions={true}
                columns={fields}
                pagination={true}
                selection={selectionValue}
                isSelectable={true}
                search={searchSettings}
                sorting={true}
                message={message}

            />
        </EuiPanel>

    );
};

export default observer(SendAgentOrdersList);
